import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DISABLE_SCROLLBAR_CLASS_NAME = 'base-ui-disable-scrollbar';
export const styleDisableScrollbar = {
  className: DISABLE_SCROLLBAR_CLASS_NAME,
  element: /*#__PURE__*/_jsx("style", {
    href: DISABLE_SCROLLBAR_CLASS_NAME,
    precedence: "base-ui:low",
    children: `.${DISABLE_SCROLLBAR_CLASS_NAME}{scrollbar-width:none}.${DISABLE_SCROLLBAR_CLASS_NAME}::-webkit-scrollbar{display:none}`
  })
};